import PropTypes from 'prop-types';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { DetailDescription, DetailList, DetailRow, DetailTerm, OrdersPropertyIcon, OrdersPropertyIdentity, Pagination, PaginationButton, PaginationEllipsis } from './styles';
import { ORDERS_PROPERTY_ICONS, formatStatus, getPaginationItems } from './helpers';

export const DetailRows = ({ rows }) => (
  <DetailList>
    {rows.map(({ label, value, content, className }) => (
      <DetailRow key={label} className={className}>
        <DetailTerm>{label}</DetailTerm>
        <DetailDescription>{content || value}</DetailDescription>
      </DetailRow>
    ))}
  </DetailList>
);

DetailRows.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export const PaginationControls = ({ currentPage, totalPages, label, onChange }) => {
  return (
    <Pagination aria-label={label}>
      <PaginationButton
        type="button"
        aria-label={`Previous ${label.toLowerCase()} page`}
        disabled={currentPage === 1}
        onClick={() => onChange(currentPage - 1)}
      >
        <FiChevronLeft aria-hidden="true" />
      </PaginationButton>
      {getPaginationItems(currentPage, totalPages).map((item) =>
        typeof item === 'number' ? (
          <PaginationButton
            key={item}
            type="button"
            aria-label={`${label} page ${item}`}
            aria-current={item === currentPage ? 'page' : undefined}
            onClick={() => onChange(item)}
          >
            {item}
          </PaginationButton>
        ) : (
          <PaginationEllipsis key={item}>…</PaginationEllipsis>
        ),
      )}
      <PaginationButton
        type="button"
        aria-label={`Next ${label.toLowerCase()} page`}
        disabled={currentPage === totalPages}
        onClick={() => onChange(currentPage + 1)}
      >
        <FiChevronRight aria-hidden="true" />
      </PaginationButton>
    </Pagination>
  );
};

PaginationControls.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const OrdersPropertyCode = ({ order, properties, propertiesLoading }) => {
  const property = (properties || []).find(
    (item) => item.propertyCode === order.propertyCode,
  );
  const propertyType = property && property.propertyType;
  const PropertyIcon =
    propertiesLoading && !property
      ? null
      : ORDERS_PROPERTY_ICONS[propertyType] || FaMapMarkerAlt;

  return (
    <OrdersPropertyIdentity title={formatStatus(propertyType || 'investment')}>
      <OrdersPropertyIcon>
        {PropertyIcon && <PropertyIcon aria-hidden="true" />}
      </OrdersPropertyIcon>
      <span>{order.propertyCode || '—'}</span>
    </OrdersPropertyIdentity>
  );
};

OrdersPropertyCode.propTypes = {
  order: PropTypes.object.isRequired,
  properties: PropTypes.arrayOf(PropTypes.object),
  propertiesLoading: PropTypes.bool,
};
